import { useCallback, useState } from "react"

const useDialog = (initialState = false) => {
  const [isVisible, setIsVisible] = useState(initialState);
  const handleToggleVisibility = useCallback(() => {
    setIsVisible((isVisible) => !isVisible)
  }, [setIsVisible])

  return [isVisible, handleToggleVisibility]
}

export default useDialog
